import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PostHogProvider } from 'posthog-js/react';
import './index.css';
import './lib/i18n';
import { initAnalytics } from './lib/analytics';
import { initPostHog, getPostHogClient } from './lib/posthog';
import { ErrorBoundary } from './components/ErrorBoundary';
import { App } from './App';

initAnalytics();
initPostHog();

const posthogClient = getPostHogClient();

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <PostHogProvider client={posthogClient}>
        <Suspense fallback={<div />}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Suspense>
      </PostHogProvider>
    </ErrorBoundary>
  </StrictMode>
);
